import { euroFormatter, obfuscateCurrency } from 'app/src/shared/helpers'
import { useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function BalanceWidget(props: { balance: number }) {
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.BalanceWidget' })
  const [showBalance, setShowBalance] = useState<boolean>(false)
  const navigate = useWelfarePortalNavigate()

  return (
    <div className='grid max-h-[153px] max-w-[445px] grid-cols-12 rounded border-l-[5px] border-[#0047BB] bg-white px-[24px] py-[16px]'>
      <div className='col-span-12 col-start-1 mb-[8px] md:col-span-5 md:col-start-8'>
        <Button
          label={showBalance ? t('HideBalance') : t('ShowBalance')}
          text
          className='mt-[0px] p-0 text-left'
          icon={showBalance ? 'pi pi-eye-slash' : 'pi pi-eye'}
          iconPos='left'
          pt={{ label: { className: 'text-[15px] font-semibold leading-[22px]' }, icon: { className: 'text-[18px]' } }}
          onClick={() => setShowBalance(!showBalance)}
        />
      </div>
      <div className='col-span-12 col-start-1' data-testid='BalanceWidget-AvailableBalance'>
        <div className='text-[18px] font-semibold leading-[18px] text-[#343434]'>{t('AvailableBalance')}</div>
        <div className='mt-2 text-[21px] font-semibold leading-[21px] text-[#4A4A4A]'>
          {showBalance && euroFormatter.format(props.balance)}
          {!showBalance && obfuscateCurrency(euroFormatter.format(props.balance), 0, 0)}
        </div>
        <Button
          label={t('GoToUserArea')}
          text
          className='mt-[8px] p-0 text-left'
          icon='pi pi-angle-right'
          iconPos='right'
          pt={{ label: { className: 'text-[15px] font-semibold leading-[22px]' }, icon: { className: 'text-[15px]' } }}
          onClick={navigate.goToUserAccount}
        />
      </div>
    </div>
  )
}
